import { getResponseFromRequestCache, invalidateRequestInCache, isValidRequestInCache, setRequestCache } from './request-cache';
import { pollRaaSAPI, formatDataSet } from './pollRaaSAPI';
import { fetchAsyncRelationalReport } from '../asyncGetDataset';
import { gate } from 'hub-http/gates';
import { getGateInfoWithOverwrite } from '../../../utils/configurationOverwrite';
const relationalAsyncReportResolveGate = gate('ReportingViz:useRelationalAsyncReportResolve');

/**
 * Abstract away async query logic into a promise which returns a dataset.
 */
export const fetchDataWithAsyncReportResolve = async params => {
  const response = await fetchAsyncRelationalReport(params);
  const formattedResponse = formatDataSet(response);
  return formattedResponse;
};
export const fetchDataLegacy = (reportWithOptions, params) => {
  // if request does not exist in the cache write to it
  if (!isValidRequestInCache(reportWithOptions)) {
    const fetchPromise = pollRaaSAPI(reportWithOptions, params);
    fetchPromise.catch(() => {
      // Invalidate the cache in case the API fails.
      invalidateRequestInCache(reportWithOptions);
    });
    setRequestCache(reportWithOptions, fetchPromise);
  }
  return getResponseFromRequestCache(reportWithOptions);
};

// TODO: we might not need this function anymore since the gate branch out is done in useSnowflakeRaaS
export const fetchData = (reportWithOptions, params, asyncResolveParams) => {
  return getGateInfoWithOverwrite().then(({
    gates = []
  }) => {
    const shouldUseAsyncReportResolve = gates === null || gates === void 0 ? void 0 : gates.includes(relationalAsyncReportResolveGate);
    if (shouldUseAsyncReportResolve) {
      return fetchDataWithAsyncReportResolve({
        payload: reportWithOptions,
        options: asyncResolveParams
      });
    }
    return fetchDataLegacy(reportWithOptions, params);
  });
};